export function matchValues() {
  const BallValue = {
    0: "Best Ball",
    1: "Best 2 Balls",
    2: "All Balls",
    3: "Best and worst ball",
  };

  const showBestBallTitle = {
    0: false,
    1: true,
    2: true,
    3: true,
    4: false,
    5: false,
    6: false,
    7: false,
    8: true,
  };

  const calculateNetScore = {
    0: false,
    1: true,
    2: false,
    3: false,
    4: false,
    5: true,
    6: false,
    7: true,
    8: true,
  };

  const showTotalBarDependsMatchType = {
    0: false,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
    8: false,
  };

  const showTwoBestBallDependsMatchType = {
    0: false,
    1: false,
    2: false,
    3: true,
    4: false,
    5: false,
    6: false,
    7: false,
    8: true,
  };

  const grosNetStringTeamTotal = {
    0: "Total:",
    1: "Net:",
    2: "Gross:",
    3: "Total (Gross):",
    4: "Total:",
    5: "Total:",
    6: "Total:",
    7: "Total:",
    8: "Total (Net)",
  };

  const showAsterik = {
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
    8: true,
  };

  // "Quota Net": 0,
  // "Quota Gross": 0,
  // "Stroke Play Net": 1,
  // "Stroke Play Gross": 2,
  // "Match Play": 3,
  // "Skins Gross": 4,
  // "Skins Net": 5,
  // "Birdie Pool Gross": 6,
  // "Birdie Pool Net": 7,
  return {
    showBestBallTitle,
    BallValue,
    calculateNetScore,
    showTotalBarDependsMatchType,
    grosNetStringTeamTotal,
    showTwoBestBallDependsMatchType,
    showAsterik,
  };
}
